import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    AccordionSummary,
    AccordionDetails,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from '../../component/addCategoryForm/addCategoryForm.module.css';
import styless from '../../component/scheduleComps/scheduleList/partList.module.css';
import { Add, Delete, UploadImg, closeCircle } from '../../Svg';
import api from '../../utils/api';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getSliders, sliderThunk } from '../../redux/appearanceSlice';

const defaultHomepageSlides = [
    {
        title: 'Smart BOM Upload & Pricing',
        description: 'Upload your BOM and move from part list to real-time sourcing insight with less manual effort.',
        image: '/assets/carousel-bom-sourcing.png',
        buttonText: 'Explore BOM Tool',
        buttonLink: '/bomManage',
    },
    {
        title: 'Global sourcing, made simple',
        description: 'Find verified component supply, compare options, and keep your procurement moving with confidence.',
        image: '/assets/carousel-global-sourcing.png',
        buttonText: 'Browse Components',
        buttonLink: '/categories',
    },
];

const getInitialSliders = (savedSliders) => {
    const managedSlides = (savedSliders || []).map((slide, index) => ({
        ...defaultHomepageSlides[index],
        ...slide,
        image: slide?.image || defaultHomepageSlides[index]?.image || '',
    })).filter((slide) => slide?.image);
    const missingDefaultSlides = defaultHomepageSlides.filter(
        (defaultSlide) => !managedSlides?.some(
            (slide) => slide?.image === defaultSlide.image || slide?.title === defaultSlide.title,
        ),
    );

    return [...(managedSlides || []), ...missingDefaultSlides];
};

const Slider = ({ Accordions, handleChange, expanded, isImage, isVideo }) => {
    const [loadings, setLoading] = useState(null)
   const dispatch = useDispatch()
    const sliderRefs = useRef([])
    const { sliders } = useSelector((state) => state.appearances)


    
    useEffect(()=>{
        dispatch(getSliders())
    },[dispatch])

    const formik = useFormik({
        initialValues: {
            sliders: getInitialSliders(sliders?.data?.[0]?.sliders),
        },
        validationSchema: Yup.object({
            sliders: Yup.array().of(
                Yup.object().shape({
                    title: Yup.string().required('Title is required'),
                    description: Yup.string().required('Description is required'),
                    image: Yup.string().required('Image is required'),
                   
                })
            ),
        }),
        onSubmit: async (values, { resetForm }) => {
            try {
                await dispatch(sliderThunk(values)).unwrap();
                resetForm({ values });
                dispatch(getSliders());
            } catch (error) {
                // The thunk already shows the API error; keep the edits in place for correction.
            }
        },
    });

    const addSlider = () => {
        formik.setFieldValue('sliders', [
            ...formik.values.sliders,
            { title: '', description: '', image: '', buttonText: '', buttonLink: '' },
        ]);
    };

    const removeSlider = (index) => {
        const updatedSliders = formik.values.sliders.filter((_, idx) => idx !== index);
        formik.setFieldValue('sliders', updatedSliders);
    };

    const handleImageChange = async (e, attribute, index) => {

        const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];
        const updatedLoading = [...(loadings || [])];
        updatedLoading[index] = true; 
        setLoading(updatedLoading);
        try {
            if (file) {

                const body = {
                    key: `${Date.now()}_${file.name}`,
                    fileType: file.type,
                    fileName: file.name,
                };

                const { data, status } = await api.getPutSignedUrl(body);
                console.log(data);

                if (status === 200) {
                    await axios.put(data.data?.preSigned, file, {
                        headers: {
                            "Content-Type": file.type
                        }
                    })

                    formik.setFieldValue(attribute, data?.data?.url)
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("Error uploading file")
        } finally {
            updatedLoading[index] = false; // Reset loading for the current index
        setLoading(updatedLoading);
        }
    };

    const handleRemove = (repo) => {
        formik.setFieldValue(repo, '');
    };

    const handleCancel = () => {
        formik.resetForm({
            values: { sliders: getInitialSliders(sliders?.data?.[0]?.sliders) },
        });
        toast.info('Unsaved changes discarded');
    };

    useEffect(() => {
        if (sliders?.data) {
            formik.setValues({ sliders: getInitialSliders(sliders.data?.[0]?.sliders) });
        }
    }, [sliders]);

    // console.log(loadings);
    
    
    return (
        <form onSubmit={formik.handleSubmit}>
            <Accordions
                sx={{ marginBottom: "20px" }}
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography
                        sx={{
                            fontSize: "16px",
                            color: "#1D1F2C",
                        }}
                    >
                        Sliders
                    </Typography>
                </AccordionSummary>

                <AccordionDetails
                    sx={{
                        background: '#fff',
                        margin: "0px 20px 20px 20px",
                    }}
                >
                    {formik.values?.sliders?.map((slider, index) => (
                        <div
                            key={index}
                            style={{
                                marginBottom: "20px",
                                padding: "22px",
                                border: "1px solid #e5e7ef",
                                borderRadius: "14px",
                                background: "#fff",
                                boxShadow: "0 8px 24px rgba(39, 20, 87, 0.05)",
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "16px", marginBottom: "18px" }}>
                                <div>
                                    <p style={{ margin: 0, color: "#5b2dbd", fontSize: "12px", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase" }}>Home page slide</p>
                                    <h3 style={{ margin: "5px 0 0", color: "#17203a", fontSize: "18px" }}>Slide {index + 1}</h3>
                                </div>
                                {formik.values.sliders.length > 1 && (
                                    <button
                                        type="button"
                                        aria-label={`Delete slide ${index + 1}`}
                                        title="Delete slide"
                                        onClick={() => removeSlider(index)}
                                        style={{ border: "none", borderRadius: "9px", background: "#fff0f2", color: "#e5485d", width: "40px", height: "40px", display: "grid", placeItems: "center", cursor: "pointer" }}
                                    >
                                        <Delete />
                                    </button>
                                )}
                            </div>

                            <div style={{ display: "grid", gridTemplateColumns: "minmax(220px, 0.72fr) minmax(0, 1.6fr)", gap: "24px", alignItems: "start" }}>
                                <div>
                                    <p className={styles.addCatLabel} style={{ margin: "0 0 8px" }}>Slide image</p>
                                    {loadings?.[index] ? (
                                        <div className={styles.uploadBox} style={{ display: "grid", placeItems: "center", minHeight: "176px" }}>Uploading image...</div>
                                    ) : (
                                        <div
                                            className={styles.uploadBox}
                                            style={{ background: "#faf9ff", cursor: "pointer", minHeight: "176px", padding: slider.image ? "0" : undefined, overflow: "hidden" }}
                                            onClick={() => sliderRefs.current[index]?.click()}
                                            onDrop={(e) => {
                                                e.preventDefault();
                                                handleImageChange(e, `sliders[${index}].image`, index);
                                            }}
                                            onDragOver={(e) => e.preventDefault()}
                                        >
                                            {slider.image ? (
                                                <>
                                                    {isImage(slider.image) && <img src={slider.image} alt={`Slide ${index + 1} preview`} style={{ width: "100%", height: "176px", display: "block", objectFit: "cover" }} />}
                                                    {isVideo(slider.image) && <video controls style={{ width: "100%", height: "176px", display: "block", objectFit: "cover" }}><source src={slider.image} type="video/mp4" /></video>}
                                                    <div className={styles.cancel_cross} onClick={(e) => { e.stopPropagation(); handleRemove(`sliders[${index}].image`); }}>{closeCircle()}</div>
                                                </>
                                            ) : (
                                                <>
                                                    <span className={styles.uploadIcon}><UploadImg /></span>
                                                    <p className={styles.addCatPara}>Drag and drop an image here, or click to upload</p>
                                                    <button type="button" className={styles.addImgBtn}>Add image/video</button>
                                                </>
                                            )}
                                            <input
                                                type="file"
                                                ref={(element) => { sliderRefs.current[index] = element; }}
                                                style={{ display: "none" }}
                                                onChange={(e) => handleImageChange(e, `sliders[${index}].image`, index)}
                                                accept="image/*,video/*"
                                            />
                                        </div>
                                    )}
                                    {slider.image && <button type="button" onClick={() => sliderRefs.current[index]?.click()} style={{ marginTop: "10px", border: "none", background: "transparent", color: "#5b2dbd", fontWeight: 700, cursor: "pointer", padding: 0 }}>Replace image</button>}
                                    {formik.errors.sliders?.[index]?.image && <div className={styles.errorText}>{formik.errors.sliders[index].image}</div>}
                                </div>

                                <div>
                                    <label className={styles.addCatLabel}>
                                        Slide title
                                        <input type="text" name={`sliders[${index}].title`} className={styles.addCatInput} placeholder="Enter slide title" value={slider.title || ""} onChange={formik.handleChange} />
                                    </label>
                                    {formik.errors.sliders?.[index]?.title && <div className={styles.errorText}>{formik.errors.sliders[index].title}</div>}

                                    <label className={styles.addCatLabel}>
                                        Short description
                                        <textarea name={`sliders[${index}].description`} className={styles.addCatTextarea} placeholder="Add a short description" value={slider.description || ""} onChange={formik.handleChange} />
                                    </label>
                                    {formik.errors.sliders?.[index]?.description && <div className={styles.errorText}>{formik.errors.sliders[index].description}</div>}

                                    <div style={{ display: "grid", gridTemplateColumns: "minmax(160px, 0.55fr) minmax(0, 1fr)", gap: "14px" }}>
                                        <label className={styles.addCatLabel}>
                                            Button text
                                            <input type="text" placeholder="Explore BOM Tool" className={styles.addCatInput} name={`sliders[${index}].buttonText`} value={slider.buttonText || ""} onChange={formik.handleChange} />
                                        </label>
                                        <label className={styles.addCatLabel}>
                                            Button link
                                            <input type="text" placeholder="/bomManage" className={styles.addCatInput} name={`sliders[${index}].buttonLink`} value={slider.buttonLink || ""} onChange={formik.handleChange} />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    <button
                        type="button"
                        className={styles.addVar}
                        onClick={addSlider}
                        style={{ cursor: 'pointer', border: "1px solid #96969696" }}
                    >
                        <Add /> Add Slider
                    </button>

                    <div className={styless.displayFlex} style={{ margin: "10px 0px 10px 0px" }}>
                        <button type="button" className={styless.cancelBtn} onClick={handleCancel} disabled={formik.isSubmitting}>Cancel</button>
                        <button className={styless.submitBtn} type="submit" disabled={formik.isSubmitting}>{formik.isSubmitting ? 'Please wait...' : 'Save changes'}</button>

                    </div>
                </AccordionDetails>
            </Accordions>
        </form>
    );
};

export default Slider;
